export const casualPageConfig = {
  "title": "New",
  "titleCN": "新进",
  "subTitle": "",
  "subTitleCN": "",
  "path": "/engagement/register",
  "defaultTab": "new",
  "tabList": [
    {
      "id": "new",
      "tabName": "New",
      "tabNameCN": "新进",
      "isHaveNotification": true,
      "notificationPath": "/engagement/register",
      "path": "/engagement/register",
      "tabIcon": "",
      "logConfig": {
        "pageId": "200601",
        "pageName": "iaa-new engaementNew",
        "extInfo": "iaa-new engaementNew",
        "pagePath": "/engagement/register"
      },
      "filters": [
        {
          "name": "NewFilter",
          "isOpenSticky": true,
          "isHaveFilterSave": true,
          "filterPath": "/engagement/register",
          "componentList": [
            {
              "name": "MetricInfo",
              "children": [
                {
                  "name": "NewUsersTrendCo",
                  "className": "",
                  "type": "view",
                  "style": {},
                  "props": {
                    "config": {
                      "api": "/api/v1/dashboard/pc/engagement/register/total_new_users",
                      "isSingle": false
                    }
                  },
                  "children": [
                    {
                      "name": "MetricComponent",
                      "path": "engagement/register",
                      "componentKey": "TotalTotalNewUsersCo"
                    },
                    {
                      "name": "MetricComponent",
                      "path": "engagement/register",
                      "componentKey": "TotalNewUsersCo"
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "margin-t-10",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "NewUsersTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/pc/engagement/register/reg_distribution",
                              "isSingle": false
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "engagement/register",
                              "componentKey": "CountryNewUsersDistributionCo"
                            }
                          ]
                        }
                      ]
                    },
                    {
                      "name": "CommonCol",
                      "className": "",
                      "type": "layout",
                      "style": {},
                      "props": {
                        "w": 12
                      },
                      "children": [
                        {
                          "name": "NewUsersTrendCo",
                          "className": "",
                          "type": "view",
                          "style": {},
                          "props": {
                            "config": {
                              "api": "/api/v1/dashboard/engagement/active/dim_metrics_trend",
                              "rawData": true,
                              "extraParams": {
                                "dim": "media_channel",
                                "metric": "new_users",
                                "accumulation": {
                                  "custom_accumulation": [
                                    {
                                      "key": "ua_network",
                                      "is_accumulation": true
                                    }
                                  ]
                                }
                              },
                              "formatData": "(data) => { const list = Array.isArray(data?.list) ? data.list : []; const channel_register_date_list = list.map(item => ({ date_md: (item?.date || '').slice(5, 10), date_ymd: item?.date, metrics: 'channel', list: (item?.kv_list || []).map(kv => ({ crz_name: kv?.key, full_crz_name: kv?.key, value: kv?.value || '0.000000', discount: '', share: '', part_of_all: '' })), total: '' })); return { channel_register_date_list }; }",
                              "isSingle": false
                            }
                          },
                          "children": [
                            {
                              "name": "MetricComponent",
                              "path": "engagement/register",
                              "componentKey": "MediaChannelNewUsersDistributionCo"
                            }
                          ]
                        }
                      ]
                    }
                  ]
                },
                {
                  "name": "CommonRow",
                  "className": "",
                  "type": "layout",
                  "style": {},
                  "props": {},
                  "children": [
                    {
                      "name": "RankListTabCo",
                      "className": "",
                      "style": {},
                      "type": "view",
                      "data": {
                        "regionDataType": "country",
                        "tabOrder": [
                          "country",
                          "region",
                          "ua_network",
                          "version",
                          "campaign"
                        ],
                        "tabMsg": {
                          "country": {
                            "aliasNameEn": "Country",
                            "aliasNameCn": "国家"
                          },
                          "region": {
                            "aliasNameEn": "Regions",
                            "aliasNameCn": "区域"
                          },
                          "ua_network": {
                            "aliasNameEn": "Media Channel",
                            "aliasNameCn": "买量渠道"
                          },
                          "version": {
                            "aliasNameEn": "版本",
                            "aliasNameCn": "Version"
                          },
                          "campaign": {
                            "aliasNameEn": "Campaign",
                            "aliasNameCn": "Campaign"
                          }
                        },
                        "optionsInit": [
                          {
                            "value": "campaign",
                            "textEn": "Campaign",
                            "textCn": "Campaign"
                          },
                          {
                            "value": "ua_network",
                            "textEn": "Media Channel",
                            "textCn": "买量渠道"
                          },
                          {
                            "value": "version",
                            "textEn": "Version",
                            "textCn": "版本"
                          }
                        ]
                      },
                      "children": [
                        {
                          "name": "MetricComponent",
                          "path": "engagement/register",
                          "componentKey": "CommonRankListCo"
                        }
                      ]
                    }
                  ]
                }
              ]
            }
          ]
        }
      ]
    }
  ]
};
